import { EVENT_ACTIONS } from '../constants';
const emitGtmEvent = ({
  gtmEventName,
  provider,
  action,
  videoId,
  playCounter
}) => {
  if (!window.dataLayer || !action) return;
  const actionToUse = action === EVENT_ACTIONS.PLAYING && playCounter.current < 1 ? EVENT_ACTIONS.START : action;
  if (action === EVENT_ACTIONS.PLAYING) {
    // eslint-disable-next-line no-param-reassign
    playCounter.current += 1;
  }
  const playCount = playCounter.current;
  window.dataLayer.push({
    event: gtmEventName,
    video_action: actionToUse,
    video_provider: provider,
    video_id: videoId,
    video_play_count: playCount
  });
};
export default emitGtmEvent;
//# sourceMappingURL=emit-gtm-event.js.map